import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuex from "vuex";
import Meta from "vue-meta";
import VueFire from "vuefire";
import $ from "jquery";
import VueLazyload from "vue-lazyload";
import "bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "../public/static/css/main.css";
import "lodash";
import VueCookie from "vue-cookie";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";
import "owl.carousel";

// Tell Vue to use the plugin
Vue.use(VueLazyload);
Vue.use(VueCookie);
Vue.use(Meta);
Vue.use(VueFire);

Vue.config.productionTip = false;

//引入FB
import "./assets/application.js";

import chara_identity from "./assets/edata/chara_identity.txt";
import equipment_craft from "./assets/edata/equipment_craft.txt";
import equipment_data from "./assets/edata/equipment_data.txt";
import equipment_enhance_rate from "./assets/edata/equipment_enhance_rate.txt";
import enemy_reward_data from "./assets/edata/enemy_reward_data.txt";
import quest_data from "./assets/edata/quest_data.txt";
import quest_area_data from "./assets/edata/quest_area_data.txt";
import unit_data from "./assets/edata/unit_data.txt";
import unit_promotion from "./assets/edata/unit_promotion.txt";
import unit_promotion_status from "./assets/edata/unit_promotion_status.txt";
import unit_rarity from "./assets/edata/unit_rarity.txt";
import wave_group_data from "./assets/edata/wave_group_data.txt";
import i18n from "./i18n";

//進入頁面後自動滑到最頂
router.beforeEach((route, path, next) => {
    store.dispatch("setGlobalLoading", { isLoading: true });
    window.scrollTo(0, 0);
    next();
});

router.afterEach((to, from, failure) => {
    store.dispatch("setGlobalLoading", { isLoading: false });
});

Vue.mixin({
    methods: {
        atou: function(str) {
            return decodeURIComponent(escape(window.atob(str)));
        },
    },
});

if (navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
            registration.unregister();
        }
    });
}

new Vue({
    router,
    store,
    created: function() {
        var self = this;
        var equipmentCraft = JSON.parse(self.atou(equipment_craft));
        var equipmentData = JSON.parse(self.atou(equipment_data));
        var equipmentEnhanceRate = JSON.parse(self.atou(equipment_enhance_rate));
        var questData = JSON.parse(self.atou(quest_data));
        var waveGroupData = JSON.parse(self.atou(wave_group_data));
        var enemyRewardData = JSON.parse(self.atou(enemy_reward_data));
        var unitData = JSON.parse(self.atou(unit_data));
        unitData = _.filter(unitData, function(o) {
            if (
                _.includes("118301,118401,120401,120501,120601,121701,121801,124301,124401,128201,128101", o.unit_id) ||
                (o.unit_id == "170101" && o.guild_id == "4")
            ) {
                return;
            }
            return o;
        });
        var questAreaData = JSON.parse(self.atou(quest_area_data));
        var unitPromotion = JSON.parse(self.atou(unit_promotion));
        var unitPromotionStatus = JSON.parse(self.atou(unit_promotion_status));
        var unitRarity = JSON.parse(self.atou(unit_rarity));
        var charaIdentity = JSON.parse(self.atou(chara_identity));
        _.forEach(equipmentCraft, function(o) {
            if (o.equipment_id == "103613") {
                o.condition_equipment_id_1 = "103613";
                o.condition_equipment_id_3 = "103611";
                o.consume_num_1 = "0";
                o.consume_num_2 = "1";
                o.consume_num_3 = "1";
            }
        });
        var gta = _.filter(unitPromotion, function(o) {
            return _.includes(o.unit_id, "105701");
        });

        var kanna = _.filter(unitPromotion, function(o) {
            return _.includes(o.unit_id, "170101");
        });
        _.forEach(gta, function(o) {
            var lv = _.find(kanna, ["promotion_level", o.promotion_level]);
            if (o.promotion_level == kanna.length) {
                lv.equip_slot_1 = o.equip_slot_1;
                lv.equip_slot_2 = o.equip_slot_2;
                lv.equip_slot_3 = o.equip_slot_3;
                lv.equip_slot_4 = o.equip_slot_4;
                lv.equip_slot_5 = o.equip_slot_5;
                lv.equip_slot_6 = o.equip_slot_6;
            }
            if (_.isUndefined(lv)) {
                var kannaNew = _.cloneDeep(o);
                kannaNew.unit_id = "170101";
                unitPromotion.push(kannaNew);
            }
        });

        store.dispatch("setEquipmentCraft", equipmentCraft);
        store.dispatch("setEquipmentData", equipmentData);
        store.dispatch("setEquipmentEnhanceRate", equipmentEnhanceRate);
        store.dispatch("setQuestData", questData);
        store.dispatch("setWaveGroupData", waveGroupData);
        store.dispatch("setEnemyRewardData", enemyRewardData);
        store.dispatch("setUnitData", unitData);
        store.dispatch("setQuestAreaData", questAreaData);
        store.dispatch("setUnitPromotion", unitPromotion);
        store.dispatch("setUnitPromotionStatus", unitPromotionStatus);
        store.dispatch("setUnitRarity", unitRarity);
        store.dispatch("setCharaIdentity", charaIdentity);
    },

    i18n,
    render: (h) => h(App),
}).$mount("#app");
